import { SubscriptionStatus, SubscriptionType } from "@/constant";

export enum BillingCycle {
  MONTHLY = 1,
  YEARLY = 2,
  FIVE_DAYS = 3,
}

export interface ISubscription {
  id: string;
  name: string;
  name_sub_title?: string;
  description?: string;
  price?: number;
  billing_cycle?: BillingCycle | number;
  is_active?: boolean;
  status?: SubscriptionStatus | number | string;
  subscription_type?: SubscriptionType | number;
  updated_at?: string;
  language?: string;
  is_most_popular?: boolean;
  apple_product_id?: string | null;
  // Parsed translations map (optional, not always provided by API)
  translations?: Record<
    string,
    Partial<{ name: string; description: string; name_sub_title: string }>
  >;
}

export interface ISubscriptionsListResponse {
  subscriptions: ISubscription[];
  totalCount: number;
}

export interface SubscriptionPayload {
  name: string;
  name_sub_title?: string;
  description?: string;
  price?: number;
  billing_cycle?: BillingCycle | number;
  is_active?: boolean;
  status?: SubscriptionStatus | number;
  subscription_type?: SubscriptionType | number;
  language?: string;
  apple_product_id?: string | null;
  // We send translations as a JSON string (consistent with Organization payloads)
  translations?: string;
}

// Minimal user type for subscription user listings
export interface ISubscriptionUser {
  id: string;
  name: string;
  email: string;
  roles?: string[];
  status?: number | string;
  profile_path?: string;
  subscription_id?: string;
  subscription_name?: string;
  subscribed_at?: string;
}

export interface ISubscriptionUsersListResponse {
  users: ISubscriptionUser[];
  totalCount: number;
}
